import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import React from 'react';
import styled from 'styled-components';
import { ThemeColors } from 'styled-components/macro';
import HeaderIcon from './HeaderIcon';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: IconDefinition;
    iconColor?: keyof ThemeColors;
    bgColor?: keyof ThemeColors;
    small?: boolean;
}

const HeaderIconButton: React.FC<IButtonProps> = ({ icon, iconColor, small, children, ...rest }) => {
    return (
        <StyledButton type="button" {...rest}>
            {icon && <HeaderIcon small={small} icon={icon} iconColor={iconColor} />}
            {children}
        </StyledButton>
    );
};

const StyledButton = styled.button`
    display: flex;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    align-items: center;
`;

export default HeaderIconButton;
